<template>
	<div class="template-wrapper">
		<h2 class="page-title">{{ $t('topup') }}</h2>
		<el-divider></el-divider>
		<template v-if="store_management === '1'">
            <template>
                <div class="equal-height-container">
                    <el-row :gutter="20">
                        <template>
                            <el-col :xs="12" :span="6" :lg="12" v-for="item in tableData" :key="item.storeid">
                                <div class="content-box">
                                    <div class="centered-content">
                                        <div class="label">{{ item.name }}<br />{{ $t("storeid") }}: {{ item.storeid }}</div>
                                        <br /><br />
                                        <el-button round @click="goToTopupplan(item.storeid)">{{ $t("topup") }}</el-button>
                                        <el-button round @click="goToTopuprecord(item.storeid)">{{ $t("topupRecord") }}</el-button>
                                        <br /><br />
                                        <h6>Token</h6>
                                        <template v-for="item2 in tableData2">
                                            <template v-if="item2.storeid === item.storeid">
                                                <div>{{ item2.start_date }} - {{ item2.end_date }} {{ $t("remainingToken") }}: {{ difference(item2.token_used, item2.token_allocated) }}</div>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                            </el-col>
                        </template>
                    </el-row>
                </div>
            </template>
		</template>
		<template v-if="store_management === '0'">
            <span>{{ $t("NoPermissions") }}</span>
        </template>



        




        

	</div>
</template>
<script>
import {
	formatDate
} from '../../assets/date.js'
import axios from 'axios'
import {
	tongyong,
	funk,
	getStore,
	addStore,
    getStoreauthorizelist,
    addStoreauthorizelist,
    editStoreauthorizelist,
    deleteStoreauthorizelist,
    getinfoStoreauthorizelist,
    addStoreposlist,
    getStoreposlist,
    storeposiplist,
    getPickupaddresslist,
    getStoreTopupusage
} from '@/api'
import {
	addAutoTemplate
} from '@/api'
export default {
	data() {
		return {
			store_management: '0',
			exportcsv: '0',
			qyid: '',
            storeid:'',
			dialogImageUrl: '',
			fileList: [],
			disabled: false,
			showViewer: false, // 显示查看器
			ewmdata: [],
			fileList: [],
			pagelist: [],
			huodonglist: [],
			currentPage: 1, // 当前页码
			pageSize: 20, // 每页显示的行数
			activeName: '0',
			dialogVisible: false,
			dialogEditFormVisible: false,
            dialogPickupAddressVisible: false,
            dialogStoreauthorizeVisible:false,
            dialogStoreauthorizeVisibleTitle:'',
            dialogStoreauthorizeVisibleStoreid: '',
            dialogAddStoreauthorizeVisible: false,
			dialogEditStoreauthorizeVisible: false,
            dialogStoreposVisible:false,
            dialogStoreposVisibleTitle:'',
            dialogStoreposVisibleStoreid: '',
            dialogAddStoreposVisible: false,
			dialogEditStoreposVisible: false,
            dialogAddStoreposipVisible: false,
			dialogEditStoreposipVisible: false,
            dialogAddPickupAddressVisible: false,
			dialogEditPickupAddressVisible: false,
			tab: [{
				label: this.$t('underApproval'),
				id: '0'
			},
			{
				label: this.$t('passed'),
				id: '1'
			}
			],
			tableData: [],
			tableData1: [

				{
					timer: '2018-01-01',
					name: '测试範本001',
					status: '审核中'
				},
			],
			metaTemplateList: [],
			status: 0,
			form: {
				qyid: '',
				storeid: '',
				name: '',
				businesswhatsapp: '',
				adminwhatsapp: '',
				adminemail: '',
                isshipping: false,
                shippingflowid: ''

			},
			editform: {
				qyid: '',
				storeid: '',
				name: '',
				businesswhatsapp: '',
				adminwhatsapp: '',
				adminemail: '',
                isshipping: false,
                shippingflowid: ''

			},
            storeauthorizeform: {
                name:'',
                loginname:'',
                password:''
            },
            storeposform: {
                name:'',
                isDefault: '0'
            },
            storeposipform: {
                ip:''
            },
            pickupAddressform: {
                location:'',
                time: ''
            },
            editstoreauthorizeformid: '',
            editstoreposformid: '',
            storeauthorizeList: [],
            storeposList: [],
            pickupaddressList: [],
            storeposipList: [],
            storeauthorizeListCurrentPage: 1, // 当前页码
            storeauthorizeListPageSize: 10, // 每页显示的行数
            storeposListCurrentPage: 1, // 当前页码
            storeposListPageSize: 10, // 每页显示的行数
            pickupaddressListCurrentPage: 1, // 当前页码
            pickupaddressListPageSize: 10, // 每页显示的行数
            storeposipListCurrentPage: 1, // 当前页码
            storeposipListPageSize: 10, // 每页显示的行数
            storeauthorizePermissionsData1: [
                {
                    id: 1,
                    name: this.$t('storeauthorizeTabPermissions_storemanagement'),
                    status: false
                },
                {
                    id: 2,
                    name: this.$t('storeauthorizeTabPermissions_exportcsv'),
                    status: false
                }
            ],
            storeauthorizePermissionsData2: [
                {
                    id: 1,
                    name: this.$t('storeauthorizeTabPermissions_membership'),
                    read_status: false,
                    edit_status: false
                },
                {
                    id: 2,
                    name: this.$t('storeauthorizeTabPermissions_broadcasting'),
                    read_status: false,
                    edit_status: false
                },
                {
                    id: 3,
                    name: this.$t('storeauthorizeTabPermissions_coupon'),
                    read_status: false,
                    edit_status: false
                },
                {
                    id: 4,
                    name: this.$t('storeauthorizeTabPermissions_chatbotsetting'),
                    read_status: false,
                    edit_status: false
                },
                {
                    id: 5,
                    name: this.$t('storeauthorizeTabPermissions_chatbotmessage'),
                    read_status: false,
                    edit_status: false
                },
                {
                    id: 6,
                    name: this.$t('storeauthorizeTabPermissions_productsetting'),
                    read_status: false,
                    edit_status: false
                },
                {
                    id: 7,
                    name: this.$t('storeauthorizeTabPermissions_order'),
                    read_status: false,
                    edit_status: false
                },
                {
                    id: 8,
                    name: this.$t('storeauthorizeTabPermissions_payment'),
                    read_status: false,
                    edit_status: false
                },
            ],
            storeauthorizePermissionsData3: [
                {
                    id: 1,
                    name: this.$t('storeauthorizeTabPermissions_managerapp'),
                    status: false
                },
            ],
            ipenable: false
            //storeauthorizePermissionsData_storemanagement: 0,
        }
	},
	filters: {
		formatDate: function (time) {
			time = time * 1000 //注意：time应为格式为13位unix時間戳，如果是10位的unix時間戳，需要乘以1000
			let date = new Date(time)
			return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
		}
	},

	created() {
		var auser = JSON.parse(window.localStorage.getItem('auserinfo'))
        this.qyid = auser.qyid
        this.storeid = auser.storeid
        this.store_management = auser.store_management
        this.exportcsv = auser.exportcsv
		this.gettemplist()
	},
	methods: {
		addstore() {
			this.dialogVisible = true
			this.form = {}
		},
		edititem(data) {
			this.form = data
			this.dialogVisible = true
		},
		beforeHandleCommand(e) {
			console.log(e);
		},
		// 页面切换方法
		handleCurrentChange(val) {
			this.currentPage = val;
		},
        handleStoreauthorizeListCurrentChange(val) {
			this.storeauthorizeListCurrentPage = val;
		},
        handleStoreposListCurrentChange(val) {
			this.storeposListCurrentPage = val;
		},
		handleClick(tab, event) {
			console.log(tab.index);
			this.status = tab.index
			this.currentPage = 1
			this.gettemplist()
		},
		handleClose() {
			this.dialogVisible = false
			this.dialogEditFormVisible = false;
            this.dialogStoreauthorizeVisible = false;
            this.dialogStoreposVisible = false;
            this.dialogPickupAddressVisible = false;
		},
        handleCloseDialogAddStoreauthorizeVisible() {
            this.dialogAddStoreauthorizeVisible = false;
        },
        handleCloseDialogEditStoreauthorizeVisible() {
            this.dialogEditStoreauthorizeVisible = false;
        },
        handleCloseDialogAddStoreposVisible() {
            this.dialogAddStoreposVisible = false;
        },
        handleCloseDialogEditStoreposVisible() {
            this.dialogEditStoreposVisible = false;
        },
        handleCloseDialogAddPickupAddressVisible() {
            this.dialogAddPickupAddressVisible = false;
        },
        handleCloseDialogEditPickupAddressVisible() {
            this.dialogEditPickupAddressVisible = false;
        },
        handleCloseDialogAddStoreposipVisible() {
            this.dialogAddStoreposipVisible = false;
        },
        handleCloseDialogEditStoreposipVisible() {
            this.dialogEditStoreposipVisible = false;
        },
		handlePictureCardPreview() {

		},
		handleRemove() {

		},
        closeDialogStorepos() {
            this.dialogStoreposVisible = false
            let fdata = {
                qyid: this.qyid,
                storeid: this.storeposipform.storeid,
                enableip: this.ipenable,
                action: "editenableip"
            }
            console.log("fdataaaaaaaaaaaaaaaaaaaaaaaaaaaa")
            console.log(fdata)
            storeposiplist(fdata).then(res => {
                if (res.code == 1) {
                    console.log(res.data);
                    //this.storeposipList = res.data;
                    //this.getlist()
                } else {
                    console.log("error")
                    this.$message({
                        type: 'error',
                        message: res.msg
                    })
                }
            })



        },
		// 新增範本点击确定
		sure() {
			var user = JSON.parse(window.localStorage.getItem('userinfo'))
			console.log(user);

			this.form.qyid = user.id
			this.form.action = "add"

			console.log(this.form);

			addStore(this.form).then(res => {
				if (res.code == 1) {
					this.$message({
						type: 'success',
						message: res.msg
					})
					this.dialogVisible = false
					this.gettemplist()
				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})
		},
		edit() {
			var user = JSON.parse(window.localStorage.getItem("userinfo"));
			console.log(user)

			this.editform.qyid = user.id
			this.editform.action = "edit"


			addStore(this.editform).then((res) => {
				if (res.code == 1) {
					this.$message({
						type: "success",
						message: res.msg,
					});
					this.dialogEditFormVisible = false;
					this.gettemplist()
				} else {
					this.$message({
						type: "error",
						message: res.msg,
					});
				}
			});
		},
		edititem(data) {
			this.editform = data
			this.dialogEditFormVisible = true
			console.log("data")
			console.log(data)
		},
        editstoreauthorize(id, storeid, title) {
            this.dialogStoreauthorizeVisible = true;
            this.dialogStoreauthorizeVisibleTitle = title;
            this.dialogStoreauthorizeVisibleStoreid = storeid;
            this.storeauthorizeform.qyid = this.qyid;
            this.storeauthorizeform.storeid = storeid;

            /*
            */

            let fdata = {
                qyid: this.qyid,
                storeid: storeid
            }
            getStoreauthorizelist(fdata).then(res => {
                if (res.code == 1) {
                    console.log(res.data);
                    this.storeauthorizeList = res.data;
                    //this.getlist()
                } else {
                    console.log("error")
                    this.$message({
                        type: 'error',
                        message: res.msg
                    })
                }
            })
            
        },
        confirmeditStoreauthorize() {
            console.log(this.editstoreauthorizeformid)
            this.storeauthorizeform.action = "edit"
            this.storeauthorizeform.id = this.editstoreauthorizeformid
            this.storeauthorizeform.permissions_storemanagement = this.storeauthorizePermissionsData1[0].status
            this.storeauthorizeform.permissions_exportcsv = this.storeauthorizePermissionsData1[1].status
            this.storeauthorizeform.permissions_managerapp_access = this.storeauthorizePermissionsData3[0].status
            this.storeauthorizeform.permissions_membership_read = this.storeauthorizePermissionsData2[0].read_status
            this.storeauthorizeform.permissions_membership_edit = this.storeauthorizePermissionsData2[0].edit_status
            this.storeauthorizeform.permissions_broadcasting_read = this.storeauthorizePermissionsData2[1].read_status
            this.storeauthorizeform.permissions_broadcasting_edit = this.storeauthorizePermissionsData2[1].edit_status
            this.storeauthorizeform.permissions_coupon_read = this.storeauthorizePermissionsData2[2].read_status
            this.storeauthorizeform.permissions_coupon_edit = this.storeauthorizePermissionsData2[2].edit_status
            this.storeauthorizeform.permissions_chatbotsetting_read = this.storeauthorizePermissionsData2[3].read_status
            this.storeauthorizeform.permissions_chatbotsetting_edit = this.storeauthorizePermissionsData2[3].edit_status
            this.storeauthorizeform.permissions_chatbotmessage_read = this.storeauthorizePermissionsData2[4].read_status
            this.storeauthorizeform.permissions_chatbotmessage_edit = this.storeauthorizePermissionsData2[4].edit_status
            this.storeauthorizeform.permissions_productsetting_read = this.storeauthorizePermissionsData2[5].read_status
            this.storeauthorizeform.permissions_productsetting_edit = this.storeauthorizePermissionsData2[5].edit_status
            this.storeauthorizeform.permissions_order_read = this.storeauthorizePermissionsData2[6].read_status
            this.storeauthorizeform.permissions_order_edit = this.storeauthorizePermissionsData2[6].edit_status
            this.storeauthorizeform.permissions_payment_read = this.storeauthorizePermissionsData2[7].read_status
            this.storeauthorizeform.permissions_payment_edit = this.storeauthorizePermissionsData2[7].edit_status

            editStoreauthorizelist(this.storeauthorizeform).then((res) => {
                console.log(res);
                if (res.code == 1) {
                    this.$message({
                        type: "success",
                        message: res.msg,
                    });
                    this.dialogEditStoreauthorizeVisible = false
                    /*
                    let fdata = {
                        qyid: this.qyid,
                        storeid: this.storeauthorizeform.storeid
                    }
                    getStoreauthorizelist(fdata).then(res => {
                        if (res.code == 1) {
                            console.log(res.data);
                            this.storeauthorizeList = res.data;
                            //this.getlist()
                        } else {
                            console.log("error")
                            this.$message({
                                type: 'error',
                                message: res.msg
                            })
                        }
                    })*/

                }
                else {
                    this.$message({
                        type: "error",
                        message: res.msg,
                    });
                }
            });
        },
        addAuthorizemember() {
            console.log('aaaddd')
            console.log(this.dialogStoreauthorizeVisibleStoreid)
            this.storeauthorizeform.name='';
            this.storeauthorizeform.loginname='';
            this.storeauthorizeform.password='';
            this.storeauthorizePermissionsData1[0].status=false
            this.storeauthorizePermissionsData1[1].status=false
            this.storeauthorizePermissionsData2[0].read_status=false
            this.storeauthorizePermissionsData2[0].edit_status=false
            this.storeauthorizePermissionsData2[1].read_status=false
            this.storeauthorizePermissionsData2[1].edit_status=false
            this.storeauthorizePermissionsData2[2].read_status=false
            this.storeauthorizePermissionsData2[2].edit_status=false
            this.storeauthorizePermissionsData2[3].read_status=false
            this.storeauthorizePermissionsData2[3].edit_status=false
            this.storeauthorizePermissionsData2[4].read_status=false
            this.storeauthorizePermissionsData2[4].edit_status=false
            this.storeauthorizePermissionsData2[5].read_status=false
            this.storeauthorizePermissionsData2[5].edit_status=false
            this.storeauthorizePermissionsData2[6].read_status=false
            this.storeauthorizePermissionsData2[6].edit_status=false
            this.storeauthorizePermissionsData2[7].read_status=false
            this.storeauthorizePermissionsData2[7].edit_status=false
            this.storeauthorizePermissionsData3[0].status=false
            this.addStoreauthorizeVisibleTab = "0";
            this.dialogAddStoreauthorizeVisible = true
        },
        addStoreauthorize() {
            this.storeauthorizeform.action = "add"
            this.storeauthorizeform.permissions_storemanagement = this.storeauthorizePermissionsData1[0].status
            this.storeauthorizeform.permissions_exportcsv = this.storeauthorizePermissionsData1[1].status
            this.storeauthorizeform.permissions_managerapp_access = this.storeauthorizePermissionsData3[0].status
            this.storeauthorizeform.permissions_membership_read = this.storeauthorizePermissionsData2[0].read_status
            this.storeauthorizeform.permissions_membership_edit = this.storeauthorizePermissionsData2[0].edit_status
            this.storeauthorizeform.permissions_broadcasting_read = this.storeauthorizePermissionsData2[1].read_status
            this.storeauthorizeform.permissions_broadcasting_edit = this.storeauthorizePermissionsData2[1].edit_status
            this.storeauthorizeform.permissions_coupon_read = this.storeauthorizePermissionsData2[2].read_status
            this.storeauthorizeform.permissions_coupon_edit = this.storeauthorizePermissionsData2[2].edit_status
            this.storeauthorizeform.permissions_chatbotsetting_read = this.storeauthorizePermissionsData2[3].read_status
            this.storeauthorizeform.permissions_chatbotsetting_edit = this.storeauthorizePermissionsData2[3].edit_status
            this.storeauthorizeform.permissions_chatbotmessage_read = this.storeauthorizePermissionsData2[4].read_status
            this.storeauthorizeform.permissions_chatbotmessage_edit = this.storeauthorizePermissionsData2[4].edit_status
            this.storeauthorizeform.permissions_productsetting_read = this.storeauthorizePermissionsData2[5].read_status
            this.storeauthorizeform.permissions_productsetting_edit = this.storeauthorizePermissionsData2[5].edit_status
            this.storeauthorizeform.permissions_order_read = this.storeauthorizePermissionsData2[6].read_status
            this.storeauthorizeform.permissions_order_edit = this.storeauthorizePermissionsData2[6].edit_status
            this.storeauthorizeform.permissions_payment_read = this.storeauthorizePermissionsData2[7].read_status
            this.storeauthorizeform.permissions_payment_edit = this.storeauthorizePermissionsData2[7].edit_status
            //this.storeauthorizeform.permissionsData1 = this.permissionsData1
            //this.storeauthorizeform.permissionsData2 = this.permissionsData2
            //this.storeauthorizeform.permissionsData1.removeItem("name")
            console.log(this.storeauthorizeform)
            addStoreauthorizelist(this.storeauthorizeform).then((res) => {
                console.log(res);
                if (res.code == 1) {
                    this.$message({
                        type: "success",
                        message: res.msg,
                    });
                    this.dialogAddStoreauthorizeVisible = false
                    let fdata = {
                        qyid: this.qyid,
                        storeid: this.storeauthorizeform.storeid
                    }
                    getStoreauthorizelist(fdata).then(res => {
                        if (res.code == 1) {
                            console.log(res.data);
                            this.storeauthorizeList = res.data;
                            //this.getlist()
                        } else {
                            console.log("error")
                            this.$message({
                                type: 'error',
                                message: res.msg
                            })
                        }
                    })

                }
                else {
                    this.$message({
                        type: "error",
                        message: res.msg,
                    });
                }
            });
        },
        editAuthorizemember(id) {
            this.editStoreauthorizeVisibleTab = "0";
            this.editstoreauthorizeformid = id
            let fdata = {
                id: id,
                action: "getinfo"
            }
            getinfoStoreauthorizelist(fdata).then((res) => {
                console.log(res)
                this.storeauthorizeform.name=res.data1.name;
                this.storeauthorizeform.loginname=res.data1.login_user;
                this.storeauthorizeform.password=res.data1.login_pw;
                this.storeauthorizePermissionsData1[0].status=res.data2.store_management
                this.storeauthorizePermissionsData1[1].status=res.data2.exportcsv
                this.storeauthorizePermissionsData2[0].read_status=res.data2.membership_read
                this.storeauthorizePermissionsData2[0].edit_status=res.data2.membership_edit
                this.storeauthorizePermissionsData2[1].read_status=res.data2.broadcasting_read
                this.storeauthorizePermissionsData2[1].edit_status=res.data2.broadcasting_edit
                this.storeauthorizePermissionsData2[2].read_status=res.data2.coupon_read
                this.storeauthorizePermissionsData2[2].edit_status=res.data2.coupon_edit
                this.storeauthorizePermissionsData2[3].read_status=res.data2.chatbot_setting_read
                this.storeauthorizePermissionsData2[3].edit_status=res.data2.chatbot_setting_edit
                this.storeauthorizePermissionsData2[4].read_status=res.data2.chatbot_message_read
                this.storeauthorizePermissionsData2[4].edit_status=res.data2.chatbot_message_edit
                this.storeauthorizePermissionsData2[5].read_status=res.data2.product_setting_read
                this.storeauthorizePermissionsData2[5].edit_status=res.data2.product_setting_edit
                this.storeauthorizePermissionsData2[6].read_status=res.data2.order_read
                this.storeauthorizePermissionsData2[6].edit_status=res.data2.order_edit
                this.storeauthorizePermissionsData2[7].read_status=res.data2.payment_read
                this.storeauthorizePermissionsData2[7].edit_status=res.data2.payment_edit
                this.storeauthorizePermissionsData3[0].status=res.data2.managerapp_access


            });
            this.dialogEditStoreauthorizeVisible = true


        },
        deleteAuthorizemember(id) {
            this.$confirm(this.$t('deleteConfirm'), {
				confirmButtonText: this.$t('Sure'),
				cancelButtonText: this.$t('Cancel')
			}).then(_ => {
                let fdata = {
                    id: id,
                    action: "delete"
                }
                deleteStoreauthorizelist(fdata).then((res) => {
                    console.log(res);
                    if (res.code == 1) {
                        this.$message({
                            type: "success",
                            message: res.msg,
                        });
                        this.dialogAddStoreauthorizeVisible = false
                        let fdata = {
                            qyid: this.qyid,
                            storeid: this.storeauthorizeform.storeid
                        }
                        getStoreauthorizelist(fdata).then(res => {
                            if (res.code == 1) {
                                console.log(res.data);
                                this.storeauthorizeList = res.data;
                                //this.getlist()
                            } else {
                                console.log("error")
                                this.$message({
                                    type: 'error',
                                    message: res.msg
                                })
                            }
                        })

                    }
                    else {
                        this.$message({
                            type: "error",
                            message: res.msg,
                        });
                    }
                });

            }).catch(_ => {

            })
            
        },
        setuppickupaddress(storeid){
            this.dialogPickupAddressVisible = true;

            let fdata = {
                qyid: this.qyid,
                storeid: storeid,
                action: "viewlist"
            }
            getPickupaddresslist(fdata).then(res => {
                if (res.code == 1) {
                    console.log(res.data);
                    this.pickupaddressList = res.data;
                    //this.getlist()
                    console.log('aaaaaaaaaaaaaaaaaaaaaaaaaa')
                } else {
                    console.log("error")
                    this.$message({
                        type: 'error',
                        message: res.msg
                    })
                    console.log('bbbbbbbbbbbbbbbbbbbbbbbbbbb')
                }
            })
            
        },
        addPickupaddress() {
            this.dialogAddPickupAddressVisible = true
            this.pickupAddresssform.name = ""
            this.pickupAddressform.isDefault = ""
        },
        confirmAddPickupaddress() {
            this.pickupAddressform.action = "add";
            this.pickupAddressform.qyid = this.qyid;
            this.pickupAddressform.storeid = this.editform.storeid;
            getPickupaddresslist(this.pickupAddressform).then((res) => {
                console.log(res);
                if (res.code == 1) {
                    this.$message({
                        type: "success",
                        message: res.msg,
                    });
                    this.dialogAddPickupAddressVisible = false
                    let fdata = {
                        qyid: this.qyid,
                        storeid: this.pickupAddressform.storeid,
                        action: "viewlist"
                    }
                    getPickupaddresslist(fdata).then(res => {
                        if (res.code == 1) {
                            console.log(res.data);
                            this.pickupaddressList = res.data;
                            //this.getlist()
                        } else {
                            console.log("error")
                            this.$message({
                                type: 'error',
                                message: res.msg
                            })
                        }
                    })

                }
                else {
                    this.$message({
                        type: "error",
                        message: res.msg,
                    });
                }
            });

        },
        editPickupaddress(id) {
            this.dialogEditPickupAddressVisible = true
            this.pickupAddressform.editid = id;
            let fdata = {
                qyid: this.qyid,
                storeid: this.editform.storeid,
                id: id,
                action: "viewinfo"
            }
            getPickupaddresslist(fdata).then(res => {
                if (res.code == 1) {
                    console.log(res.data);
                    //this.storeposList = res.data;
                    //this.getlist()
                    this.pickupAddressform.location = res.data.location
                    this.pickupAddressform.time = res.data.time
                } else {
                    console.log("error")
                    this.$message({
                        type: 'error',
                        message: res.msg
                    })
                }
            })
        },
        confirmEditPickupaddress() {
            this.pickupAddressform.action = "edit";
            let fdata = {
                qyid: this.qyid,
                storeid: this.editform.storeid,
                id: this.pickupAddressform.editid,
                location: this.pickupAddressform.location,
                time: this.pickupAddressform.time,
                action: "edit"
            }
            console.log(fdata)
            getPickupaddresslist(fdata).then((res) => {
                console.log(res);
                if (res.code == 1) {
                    this.$message({
                        type: "success",
                        message: res.msg,
                    });
                    this.dialogEditPickupAddressVisible = false
                    
                    let fdata2 = {
                        qyid: this.qyid,
                        storeid: this.editform.storeid,
                        action: "viewlist"
                    }
                    getPickupaddresslist(fdata2).then(res => {
                        if (res.code == 1) {
                            console.log(res.data);
                            this.pickupaddressList = res.data;
                            //this.getlist()
                        } else {
                            console.log("error")
                            this.$message({
                                type: 'error',
                                message: res.msg
                            })
                        }
                    })

                }
                else {
                    this.$message({
                        type: "error",
                        message: res.msg,
                    });
                }
            });

        },
        deletePickupaddress(id, storeid) {
            this.$confirm(this.$t('deleteConfirm'), {
				confirmButtonText: this.$t('Sure'),
				cancelButtonText: this.$t('Cancel')
			}).then(_ => {
				let deletedata = {
					action: 'delete',
					id: id,
				}
				getPickupaddresslist(deletedata).then((res) => {
					if (res.code == 1) {
						this.$message({
							type: "success",
							message: res.msg,
						});
                        let fdata = {
                            qyid: this.qyid,
                            storeid: storeid,
                            action: "viewlist"
                        }
                        getPickupaddresslist(fdata).then(res => {
                            if (res.code == 1) {
                                console.log(res.data);
                                this.pickupaddressList = res.data;
                                //this.getlist()
                                console.log('aaaaaaaaaaaaaaaaaaaaaaaaaa')
                            } else {
                                console.log("error")
                                this.$message({
                                    type: 'error',
                                    message: res.msg
                                })
                                console.log('bbbbbbbbbbbbbbbbbbbbbbbbbbb')
                            }
                        })

					} else {
						this.$message({
							type: "error",
							message: res.msg,
						});
					}
				});
			}).catch(_ => {



			})
        },
        editstorepos(id, storeid, title) {
            this.dialogStoreposVisible = true;
            this.dialogStoreposVisibleTitle = title;
            this.dialogStoreposVisibleStoreid = storeid;
            this.storeposform.qyid = this.qyid;
            this.storeposform.storeid = storeid;
            this.storeposipform.qyid = this.qyid;
            this.storeposipform.storeid = storeid;

            this.storePOSVisibleTab = "0";
            /*
            */

            let fdata = {
                qyid: this.qyid,
                storeid: storeid,
                action: "viewlist"
            }
            getStoreposlist(fdata).then(res => {
                if (res.code == 1) {
                    console.log(res.data);
                    this.storeposList = res.data;
                    //this.getlist()
                    console.log('aaaaaaaaaaaaaaaaaaaaaaaaaa')
                } else {
                    console.log("error")
                    this.$message({
                        type: 'error',
                        message: res.msg
                    })
                    console.log('bbbbbbbbbbbbbbbbbbbbbbbbbbb')
                }
            })
            
        },
        addStorepos() {
            this.dialogAddStoreposVisible = true
            this.storeposform.name = ""
            this.storeposform.isDefault = "0"
        },
        confirmAddStorepos() {
            this.storeposform.action = "add";
            addStoreposlist(this.storeposform).then((res) => {
                console.log(res);
                if (res.code == 1) {
                    this.$message({
                        type: "success",
                        message: res.msg,
                    });
                    this.dialogAddStoreposVisible = false
                    let fdata = {
                        qyid: this.qyid,
                        storeid: this.storeposform.storeid,
                        action: "viewlist"
                    }
                    getStoreposlist(fdata).then(res => {
                        if (res.code == 1) {
                            console.log(res.data);
                            this.storeposList = res.data;
                            //this.getlist()
                        } else {
                            console.log("error")
                            this.$message({
                                type: 'error',
                                message: res.msg
                            })
                        }
                    })

                }
                else {
                    this.$message({
                        type: "error",
                        message: res.msg,
                    });
                }
            });

        },
        editStorepos(id) {
            this.dialogEditStoreposVisible = true
            this.storeposform.editid = id;
            let fdata = {
                qyid: this.qyid,
                storeid: this.storeposform.storeid,
                id: id,
                action: "viewinfo"
            }
            getStoreposlist(fdata).then(res => {
                if (res.code == 1) {
                    console.log(res.data);
                    //this.storeposList = res.data;
                    //this.getlist()
                    this.storeposform.name = res.data.name
                    this.storeposform.isDefault = res.data.isDefault
                } else {
                    console.log("error")
                    this.$message({
                        type: 'error',
                        message: res.msg
                    })
                }
            })
        },
        confirmEditStorepos() {
            this.storeposform.action = "edit";
            let fdata = {
                qyid: this.qyid,
                storeid: this.storeposform.storeid,
                id: this.storeposform.editid,
                name: this.storeposform.name,
                isDefault: this.storeposform.isDefault,
                action: "edit"
            }
            console.log(fdata)
            addStoreposlist(fdata).then((res) => {
                console.log(res);
                if (res.code == 1) {
                    this.$message({
                        type: "success",
                        message: res.msg,
                    });
                    this.dialogEditStoreposVisible = false
                    
                    let fdata2 = {
                        qyid: this.qyid,
                        storeid: this.storeposform.storeid,
                        action: "viewlist"
                    }
                    getStoreposlist(fdata2).then(res => {
                        if (res.code == 1) {
                            console.log(res.data);
                            this.storeposList = res.data;
                            //this.getlist()
                        } else {
                            console.log("error")
                            this.$message({
                                type: 'error',
                                message: res.msg
                            })
                        }
                    })

                }
                else {
                    this.$message({
                        type: "error",
                        message: res.msg,
                    });
                }
            });

        },
        deleteStorepos(id, storeid) {
            this.$confirm(this.$t('deleteConfirm'), {
				confirmButtonText: this.$t('Sure'),
				cancelButtonText: this.$t('Cancel')
			}).then(_ => {
				let deletedata = {
					action: 'delete',
					id: id,
				}
				getStoreposlist(deletedata).then((res) => {
					if (res.code == 1) {
						this.$message({
							type: "success",
							message: res.msg,
						});
                        let fdata = {
                            qyid: this.qyid,
                            storeid: storeid,
                            action: "viewlist"
                        }
                        getStoreposlist(fdata).then(res => {
                            if (res.code == 1) {
                                console.log(res.data);
                                this.storeposList = res.data;
                                //this.getlist()
                                console.log('aaaaaaaaaaaaaaaaaaaaaaaaaa')
                            } else {
                                console.log("error")
                                this.$message({
                                    type: 'error',
                                    message: res.msg
                                })
                                console.log('bbbbbbbbbbbbbbbbbbbbbbbbbbb')
                            }
                        })

					} else {
						this.$message({
							type: "error",
							message: res.msg,
						});
					}
				});
			}).catch(_ => {



			})
        },
        addStoreposipwhitelist() {
            this.dialogAddStoreposipVisible = true
            this.storeposipform.ip = ""
        },
        confirmAddStoreposip() {
            this.storeposipform.action = "add";
            storeposiplist(this.storeposipform).then((res) => {
                console.log(res);
                if (res.code == 1) {
                    this.$message({
                        type: "success",
                        message: res.msg,
                    });
                    this.dialogAddStoreposipVisible = false
                    let fdata = {
                        qyid: this.qyid,
                        storeid: this.storeposipform.storeid,
                        action: "viewlist"
                    }
                    storeposiplist(fdata).then(res => {
                        if (res.code == 1) {
                            console.log(res.data);
                            this.storeposipList = res.data;
                            this.ipenable = res.enableIP;
                            //this.getlist()
                        } else {
                            console.log("error")
                            this.$message({
                                type: 'error',
                                message: res.msg
                            })
                        }
                    })

                }
                else {
                    this.$message({
                        type: "error",
                        message: res.msg,
                    });
                }
            });

        },
        editStoreposip(id) {
            this.dialogEditStoreposipVisible = true
            this.storeposipform.editid = id;
            let fdata = {
                qyid: this.qyid,
                storeid: this.storeposipform.storeid,
                id: id,
                action: "viewinfo"
            }
            storeposiplist(fdata).then(res => {
                if (res.code == 1) {
                    console.log(res.data);
                    //this.storeposList = res.data;
                    //this.getlist()
                    this.storeposipform.ip = res.data.ip
                } else {
                    console.log("error")
                    this.$message({
                        type: 'error',
                        message: res.msg
                    })
                }
            })
        },
        confirmEditStoreposip() {
            this.storeposipform.action = "edit";
            let fdata = {
                qyid: this.qyid,
                storeid: this.storeposipform.storeid,
                id: this.storeposipform.editid,
                ip: this.storeposipform.ip,
                action: "edit"
            }
            console.log(fdata)
            storeposiplist(fdata).then((res) => {
                console.log(res);
                if (res.code == 1) {
                    this.$message({
                        type: "success",
                        message: res.msg,
                    });
                    this.dialogEditStoreposipVisible = false
                    
                    let fdata2 = {
                        qyid: this.qyid,
                        storeid: this.storeposipform.storeid,
                        action: "viewlist"
                    }
                    storeposiplist(fdata2).then(res => {
                        if (res.code == 1) {
                            console.log(res.data);
                            this.storeposipList = res.data;
                            this.ipenable = res.enableIP;
                            //this.getlist()
                        } else {
                            console.log("error")
                            this.$message({
                                type: 'error',
                                message: res.msg
                            })
                        }
                    })

                }
                else {
                    this.$message({
                        type: "error",
                        message: res.msg,
                    });
                }
            });

        },
        deleteStoreposip(id, storeid) {
            this.$confirm(this.$t('deleteConfirm'), {
				confirmButtonText: this.$t('Sure'),
				cancelButtonText: this.$t('Cancel')
			}).then(_ => {
				let deletedata = {
					action: 'delete',
					id: id,
				}
				storeposiplist(deletedata).then((res) => {
					if (res.code == 1) {
						this.$message({
							type: "success",
							message: res.msg,
						});
                        let fdata = {
                            qyid: this.qyid,
                            storeid: storeid,
                            action: "viewlist"
                        }
                        storeposiplist(fdata).then(res => {
                            if (res.code == 1) {
                                console.log(res.data);
                                this.storeposipList = res.data;
                                this.ipenable = res.enableIP;
                                //this.getlist()
                                console.log('aaaaaaaaaaaaaaaaaaaaaaaaaa')
                            } else {
                                console.log("error")
                                this.$message({
                                    type: 'error',
                                    message: res.msg
                                })
                                console.log('bbbbbbbbbbbbbbbbbbbbbbbbbbb')
                            }
                        })

					} else {
						this.$message({
							type: "error",
							message: res.msg,
						});
					}
				});
			}).catch(_ => {



			})
        },
        handleStoreposTabClick() {
            switch (this.storePOSVisibleTab) {
                case "1":
                    let fdata = {
                        qyid: this.qyid,
                        storeid: this.storeposipform.storeid,
                        action: "viewlist"
                    }
                    storeposiplist(fdata).then(res => {
                        if (res.code == 1) {
                            console.log(res.data);
                            console.log(res.enableIP);
                            this.storeposipList = res.data;
                            this.ipenable = res.enableIP;
                            //this.getlist()
                        } else {
                            console.log("error")
                            this.$message({
                                type: 'error',
                                message: res.msg
                            })
                        }
                    })
                    break;

            }
        },
        changedata1(id){
            console.log(id)
        },
		//删除某个
		delitem(id) {
			this.$confirm(this.$t('deleteConfirm'), {
				confirmButtonText: this.$t('Sure'),
				cancelButtonText: this.$t('Cancel')
			}).then(_ => {

				console.log('del..');
				var user = JSON.parse(window.localStorage.getItem("userinfo"));
				let deletedata = {
					action: 'delete',
					id: id,
					qyid: user.id
				}
				addStore(deletedata).then((res) => {
					if (res.code == 1) {
						this.$message({
							type: "success",
							message: res.msg,
						});
						this.dialogVisible = false
						this.gettemplist()
					} else {
						this.$message({
							type: "error",
							message: res.msg,
						});
					}
				});
			}).catch(_ => {



			})


		},
		// 我的範本列表
		gettemplist() {
			console.log('go taocan');
			var user = JSON.parse(window.localStorage.getItem('userinfo'))

			/*
			let fdata = {
				sjk: 'messenger_storelist',
				action: 'list',
				qyid: user.id
			}
			tongyong(fdata).then(res => {
				if (res.code == 1) {
					console.log(fdata);
					console.log(res);
					this.tableData = res.data
				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})*/
			let fdata = {
				qyid: this.qyid,
                storeid: this.storeid
			};
			getStoreTopupusage(fdata).then((res) => {
				if (res.code == 1) {
					console.log(res);
					this.tableData = res.data;
                    this.tableData2 = res.data2;
				} else {
					this.$message({
						type: "error",
						message: res.msg,
					});
				}
			});
		},


		//pagelist 
		getpagelist() {
			console.log('go taocan');
			var user = JSON.parse(window.localStorage.getItem('userinfo'))

			let fdata = {
				sjk: 'messenger_pagelist',
				action: 'list',

				qyid: user.id
			}
			tongyong(fdata).then(res => {
				if (res.code == 1) {
					console.log(res);
					this.pagelist = res.data
				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})
		},

		//pagelist 
		gethuodonglist() {
			console.log('go taocan');
			var user = JSON.parse(window.localStorage.getItem('userinfo'))

			let fdata = {
				sjk: 'messenger_huodong_yhq',
				action: 'list',

				qyid: user.id
			}
			tongyong(fdata).then(res => {
				if (res.code == 1) {
					console.log(res);
					this.huodonglist = res.data
				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})
		},
        goToTopupplan(topupstoreid) {
            this.$router.push({ name: 'topupplan', params: { topupstoreid: topupstoreid } })
        },
        goToTopuprecord(topupstoreid) {
            this.$router.push({ name: 'topuprecord', params: { topupstoreid: topupstoreid } })
        },

        difference(item1, item2) {
            return item2 - item1
        },
		ewm(str, pageid) {
			var user = JSON.parse(window.localStorage.getItem('userinfo'))
			console.log(user);
			this.dialogVisible_ewm = true
			this.qyid = user.id
			let fdata = {
				do: 'ewm',
				qyid: this.qyid,
				pageid: pageid,
				ref: str,
				type: 'link',


			}
			console.log('go ewm', fdata);


			funk(fdata).then(res => {
				if (res.code == 1) {
					console.log(res);
					this.ewmdata = res
					console.log(this.ewmdata)
					// const html ='<div style="text-algin:center;">H5:<a target="_blank"  href="'+res.url+'">link</a> <br><img src='+res.path+' /> <br>Whatsapp:<a target="_blank"  href="'+res.wurl+'">link</a> <button class="tag-read" :data-clipboard-text="aaa" @click="copy">复制</button></el-button><br> <img src='+res.whatsapp+' /> <br></div>' 
					// this.$alert(html, '預約排隊二維碼', {
					//           dangerouslyUseHTMLString: true
					//         });


				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})
		},
		//上传--

		// 删除
		handleRemove(file) {
			let uploadFiles = this.$refs.elUpload.uploadFiles;
			uploadFiles.forEach((value, index) => {
				if (value.uid === file.uid) {
					uploadFiles.splice(index, 1)
					this.fileList.splice(index, 1)
				}
			})
		},
		// 大图预览
		handlePictureCardPreview(file) {
			this.dialogImageUrl = file.url;
			this.showViewer = true;
		},
		// 下载圖片
		handleDownload(file) {
			let a = document.createElement('a');
			a.download = file.name;
			a.href = (file.url);
			a.click();
		},
		// 重写上传
		uploadSectionFile(params) {
			const file = params.file,
				fileType = file.type,
				isImage = fileType.indexOf('image') !== -1,
				isLt2M = file.size / 1024 / 1024 < 2;
			// 这里常规检验，看项目需求而定
			if (!isImage) {
				this.$message.error('只能上传圖片格式png、jpg、gif!');
				return;
			}
			if (!isLt2M) {
				this.$message.error('只能上传圖片大小小于2M');
				return;
			}
			// 根据后台需求数据格式
			const form1 = new FormData();
			// 文件对象
			form1.append('file', file);
			// 本例子主要要在请求时新增特定属性，所以要用自己方法覆盖默认的action
			// form.append("clientType", 'xxx');
			// 项目封装的请求方法，下面做简单介绍


			imageUpload(form1).then(res => {
				//自行处理各种情况
				console.log('res', res)
				this.form.image = res
			}).catch(() => {
				// xxx
			});
		},
		// 关闭
		closeViewer() {
			this.showViewer = false;
		},
		sortChange({ prop, order }) {
			this.tableData.sort(this.compare(prop, order));
		},
		compare(propertyName, sort) {
			return function (obj1, obj2) {
				var value1 = obj1[propertyName]
				var value2 = obj2[propertyName]
				if (typeof value1 === 'string' && typeof value2 === 'string') {
					const res = value1.localeCompare(value2, 'zh')
					return sort === 'ascending' ? res : -res
				} else {
					if (value1 <= value2) {
						return sort === 'ascending' ? -1 : 1
					} else if (value1 > value2) {
						return sort === 'ascending' ? 1 : -1
					}
				}
			}
		}




	}
}
</script>
<style lang="scss" scoped>
.equal-height-container {
  display: flex;
}

.el-row {
  display: flex;
  flex: 1;
  flex-wrap: wrap;
}

.el-col {
  display: flex;
  margin-bottom: 20px; /* Replace gutter for flexbox */
}

.content-box {
  flex: 1;
  background: #f5f7fa;
  padding: 20px;
  border-radius: 4px;
  width: 100%;
}

/* For extra small screens */
@media (max-width: 768px) {
  .el-col {
    flex: 0 0 calc(50% - 10px); /* xs=12 means 50% width */
    margin: 0 5px 20px 5px;
  }
}

/* For large screens */
@media (min-width: 1200px) {
  .el-col {
    flex: 0 0 calc(50% - 10px); /* lg=12 means 50% width */
    margin: 0 5px 20px 5px;
  }
}

/* For medium screens (span=6 means 25% width) */
@media (min-width: 769px) and (max-width: 1199px) {
  .el-col {
    flex: 0 0 calc(25% - 15px);
    margin: 0 7.5px 20px 7.5px;
  }
}

.centered-content {
  text-align: center; /* Center text content */
}

.el-pagination__total {
	display: inline-block;
	font-size: 13px;
	min-width: 35.5px;
	height: 28px;
	line-height: 28px;
	vertical-align: top;
	box-sizing: border-box;
}

.pagination {
	width: 100%;
	margin: 30px auto;
}

::v-deep .el-select {
	width: 100%;

}

.label {
    font-size: 24px;
    font-weight: bold;
    color: rgba(0, 0, 0, .45);
    text-align: center;
}

@media screen and (max-width: 768px) {
    .label {
        font-size: 12px;
        text-align: center;
    }
}
</style>
